<main [ngClass]="appDataService.contrastMode ? 'pia-contrast' : ''">
  <app-header></app-header>
  <router-outlet></router-outlet>
</main>
